import {
  highlightBackgroundColor,
  highlightTextColor,
} from "../../useReadAloudAudio.style";

const setActiveSpan = (span, isActive = true) => {
  if (!span) return;

  if (isActive) {
    span.style.setProperty("background", highlightBackgroundColor);
    span.style.setProperty("color", highlightTextColor);
    span.setAttribute("data-current", "true");
  } else {
    span.style.removeProperty("background");
    span.style.removeProperty("color");
    span.removeAttribute("data-current");
  }
};

export default setActiveSpan;
